import { styled, TableRow } from '@mui/material';

/**
 * Row avec style CSS
 */
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#fbfcfe',
    },
    '& td, & th': {
        borderBottom: '1px solid #e7edf5',
        transition: 'background-color 0.2s ease',
    },
    '&:hover td, &:hover th': {
        backgroundColor: '#f4f8fc',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
